import { create } from 'zustand';
import { ILogsFilter } from '@/modules/Analytics/Analytics.types.ts';
import { DATE_FORMAT } from '@/const';
import { tzDatetime } from '@/modules/DateTime/utils';

type IAnalyticsState = {
    isAnalyticsOpened: boolean;
    toggleAnalytics: () => void;
    filters: ILogsFilter;
    foldAnalytics: () => void;
    setFilters: (filters: Partial<ILogsFilter>) => void;
    clearFilters: () => void;
    isLoading: boolean;
    setLoading: (isLoading: boolean) => void;
};

const getDefaultFromDate = () => {
    return tzDatetime().minus({ weeks: 2 }).toFormat(DATE_FORMAT.FULL_12H);
};

const initialFilters: ILogsFilter = {
    per: 50,
    from_datetime: getDefaultFromDate(),
    to_datetime: '',
    levels: [],
    log_types: [],
    external_event_id: '',
    runtime_context_id: '',
    userPersona: undefined,
    userActor: undefined,
    agentPersona: undefined,
    message: ''
};

const initialState = {
    isAnalyticsOpened: false,
    isLoading: false,
    filters: initialFilters
};

const useAnalyticsStore = create<IAnalyticsState>()((set) => ({
    ...initialState,
    toggleAnalytics: () => {
        set((state) => ({ isAnalyticsOpened: !state.isAnalyticsOpened }));
    },
    foldAnalytics: () => {
        set({ isAnalyticsOpened: false });
    },
    setFilters: (filters) => {
        set((state) => ({ filters: { ...state.filters, ...filters } }));
    },
    clearFilters: () => {
        set({ filters: { ...initialFilters, from_datetime: '' } });
    },
    setLoading: (isLoading) => {
        set({ isLoading });
    }
}));

export default useAnalyticsStore;
